<template>
    <div class="top">
        <div v-if="isPc" class="header-act">
            <div class="logo-wrap" @click="navigateTo('/')">
                <img src="https://file.zmxs.com.cn/img/newLogo2026-09-02140101.png" alt="" class="logo-img " />
            </div>
            <div class="nav-menu">
                <template v-for="(m, i) in menuArr">
                    <a
                        v-if="m.type === 'link'"
                        :key="'nav-link-' + (m.to || i)"
                        :class="{ page: true, actcolor: isMenuActive(m) }"
                        :href="resolveHref(m.to)"
                        @click.prevent="navigateTo(m.to)"
                    >{{ m.label }}</a>
                    <div
                        v-else-if="m.type === 'dropdown'"
                        :key="'nav-drop-' + (m.label || i)"
                        class="nav-dropdown"
                        @mouseenter="handleDropdownEnter(m.label)"
                        @mouseleave="handleDropdownLeave"
                    >
                        <div class="el-dropdown-link" :class="{ 'is-open': openDropdownKey === m.label }">
                            <span>{{ m.label }}</span>
                            <i class="el-icon-arrow-down"></i>
                        </div>
                        <div class="dropdown-panel" :class="{ 'is-open': openDropdownKey === m.label }">
                            <div
                                v-for="(child, j) in m.children"
                                :key="'drop-item-' + (child.command || j)"
                                class="dropdown-item"
                                :class="{ 'is-active': isDropdownChildActive(child) }"
                                @click="handleDropCommand(child.command)"
                            >
                                <div class="dropdown-item__value">{{ child.value }}</div>
                                <div class="dropdown-item__label">{{ child.label }}</div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div class="right-wrap">
                <div @click="handBtn" class="try-btn">企业端登录</div>
            </div>
        </div>
        <div v-else class="mobile-header">
            <div v-if="isBack" @click="goback" style="color: #2F2F2F;font-size: 33px;">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="mobile-header__logo">
                <img src="https://file.zmxs.com.cn/img/newLogo2026-09-02140101.png" alt="" class="mobile-header__logo-img">
            </div>
            <button
                type="button"
                class="mobile-header__toggle"
                :class="{ 'is-open': mobileMenuOpen }"
                @click="toggleMobileMenu"
                aria-label="切换导航菜单"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <transition name="mobile-menu-slide">
                <div v-show="mobileMenuOpen" class="mobile-menu-panel">
                    <div
                        v-for="(m, i) in menuArr"
                        :key="'mobile-nav-' + (m.to || m.label || i)"
                        class="mobile-menu-item"
                    >
                        <template v-if="m.type === 'link'">
                            <div
                                class="mobile-menu-item__main"
                                :class="{ 'is-active': isMenuActive(m) }"
                                @click="navigateTo(m.to)"
                            >
                                <span>{{ m.label }}</span>
                            </div>
                        </template>
                        <template v-else>
                            <div class="mobile-menu-item__main" @click="toggleMobileProduct">
                                <span>产品中心</span>
                                <i class="mobile-menu-item__arrow" :class="{ 'is-open': mobileProductOpen }"></i>
                            </div>
                            <transition name="mobile-submenu-slide">
                                <div v-show="mobileProductOpen" class="mobile-submenu">
                                    <div
                                        v-for="(child, j) in m.children"
                                        :key="'mobile-child-' + (child.command || j)"
                                        class="mobile-submenu__item"
                                        :class="{ 'is-active': isDropdownChildActive(child) }"
                                        @click="handleDropCommand(child.command)"
                                    >
                                        {{ child.value }}
                                    </div>
                                </div>
                            </transition>
                        </template>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { removeUser } from "@/plugins/auth.js";
import { eventLog } from "@/utils/index.js";
import { menuArr, routerList } from "@/router/config.js";
import { resolveHref } from "@/multi/pageRoutes";
import { determineDeviceType } from "@/plugins/untils.js";
import { jumpBUrl } from "@/apis/apis.js";

export default {
    props: {
        isBack: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const currentRoute = this.$route || { params: {}, name: '' };
        return {
            routeParams: currentRoute.params || {},
            user: "",
            isDark: false,
            isPc: true,
            openDropdownKey: null,
            mobileMenuOpen: false,
            mobileProductOpen: true,
            resizeHandler: null,
            menuArr,
            routerList
        };
    },
    created() {
        //获取b端小程序地址 并挂在windows上
        if(!determineDeviceType()){
            jumpBUrl().then(res => {
                if (res.data.code == 200) {
                    window.jumpBUrl = res.data.data;
                }
            })
        }
        this.mql = window.matchMedia('(prefers-color-scheme: dark)');
        this.isDark = this.mql.matches;
        this.applyTheme(this.isDark);

        this.onSystemThemeChange = (e) => {
            this.isDark = e.matches;
            this.applyTheme(this.isDark);
            window.dispatchEvent(new CustomEvent('theme-updated', { detail: this.isDark }));
            this.$root.$emit('theme-updated', this.isDark);
        };
        this.mql.addEventListener('change', this.onSystemThemeChange);

        this.onThemeUpdate = (e) => {
            this.isDark = e.detail;
            this.applyTheme(this.isDark);
        };
        window.addEventListener('theme-updated', this.onThemeUpdate);
        eventLog(this.routerList[(this.$route && this.$route.name) || ''])
    },
    mounted() {
        this.resizeHandler = () => {
            this.isPc = determineDeviceType();
            if (this.isPc) {
                this.mobileMenuOpen = false;
            }
        };
        this.resizeHandler();
        window.addEventListener('resize', this.resizeHandler);
    },
    beforeDestroy() {
        window.removeEventListener('theme-updated', this.onThemeUpdate);
        window.removeEventListener('resize', this.resizeHandler);
        if (this.mql) {
            this.mql.removeEventListener('change', this.onSystemThemeChange);
        }
    },
    watch: {
        $route: {
            handler: function (val) {
                Object.assign(this.routeParams, (val && val.params) || {});
                this.mobileMenuOpen = false;
            },
            deep: true,
        },
    },
    methods: {
        goback(){
            window.history.back();
        },
        applyTheme(isDark) {
            const root = document.documentElement;
            if (isDark) {
                root.style.setProperty('--header-bg', '#120E30');
                root.style.setProperty('--nav-text', '#EFF1FB');
                root.style.setProperty('--nav-active', '#ffffff');
                root.style.setProperty('--dropdown-bg', '#1c1742');
                root.style.setProperty('--dropdown-hover', '#2b245c');
                root.style.setProperty('--body-bg', '#120E30');
                root.style.setProperty('--top-bg', '#0A0C1E');
                root.style.setProperty('--nav1-text', '#EFF1FB');
                root.style.setProperty('--two-bg', '#0A0C1E');
                root.style.setProperty('--card-shadow', 'none');
                root.style.setProperty('--card-border', 'none');
                root.style.setProperty('--item-border', 'none');
            } else {
                root.style.setProperty('--header-bg', '#ffffff');
                root.style.setProperty('--nav-text', '#222');
                root.style.setProperty('--nav-active', '#953de8');
                root.style.setProperty('--dropdown-bg', '#ffffff');
                root.style.setProperty('--dropdown-hover', '#f0f0f0');
                root.style.setProperty('--body-bg', '#f7f8fc');
                root.style.setProperty('--top-bg', '#fff');
                root.style.setProperty('--two-bg', '#FBF8FF');
                root.style.setProperty('--nav1-text', 'rgba(102, 102, 102, 0.72)');
                root.style.setProperty('--card-shadow', '0px 26px 52px 0px #D2C9EB');
                root.style.setProperty('--card-border', '1px solid #D8CBFF');
                root.style.setProperty('--item-border', '0px 18px 48px 0px #E5DEF9');
            }
        },
        handBtn() {
            eventLog('click_free_try')
            window.open('https://job.zmxs.com.cn')
        },
        resolveHref,
        navigateTo(location) {
            const href = resolveHref(location);
            window.location.assign(href);
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
        toggleMobileProduct() {
            this.mobileProductOpen = !this.mobileProductOpen;
        },
        edit() {
            removeUser();
            this.navigateTo("/login");
        },
        handleDropCommand(path) {
            this.openDropdownKey = null;
            this.navigateTo(path);
        },
        handleDropdownEnter(label) {
            this.openDropdownKey = label;
        },
        handleDropdownLeave() {
            this.openDropdownKey = null;
        },
        isDropdownChildActive(child) {
            const currentPath = ((this.$route && this.$route.path) || '').replace(/\/+$/, '') || '/';
            const childPath = (child && child.command ? child.command : '').replace(/\/+$/, '') || '/';
            return currentPath === childPath;
        },
        isMenuActive(menu) {
            if (!menu || !menu.activeNames || !menu.activeNames.length) return false;
            return menu.activeNames.indexOf((this.$route && this.$route.name) || '') > -1;
        },
        toggleTheme() {
            this.isDark = !this.isDark;
            this.applyTheme(this.isDark);
            window.dispatchEvent(new CustomEvent('theme-updated', { detail: this.isDark }));
            this.$root.$emit('theme-updated', this.isDark)
        }
    },
    computed: {
        info() {
            return this.$store.state.userstore.userInfo;
        },
    },
};
</script>

<style lang="less" scoped>
.top {
    width: 100%;
    min-height: 72px;
    background-color: #fff;
    border-bottom: 1px solid rgba(184, 108, 255, 0.15);
    transition: background 0.35s;
    position: relative;
    z-index: 40;

    .header-act {
        height: 72px;
        max-width: 1280px;
        width: 92%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo-wrap {
            cursor: pointer;

            .logo-img {
                width: 128px;
                height: 33px;
            }
        }

        .nav-menu {
            display: flex;
            align-items: center;
            gap: 8px;

            .page {
                padding: 0 16px;
                color: #76708A;
                font-size: 16px;
                text-decoration: none;
                transition: color 0.3s;
            }

            .actcolor {
                color: #222 !important;
                font-weight: 600;
            }

            .page:hover {
                color: #222;
            }

            .el-dropdown-link {
                position: relative;
                padding: 0 16px;
                color: #76708A;
                font-size: 16px;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 4px;
                transition: color 0.3s;

                &:hover {
                    color: #222;
                }

                &.is-open {
                    color: #222;
                }

                i {
                    font-size: 14px;
                    transition: transform 0.25s ease;
                }

                &.is-open i {
                    transform: rotate(180deg);
                }
            }

            .nav-dropdown {
                position: relative;
                padding: 22px 0;
                margin: -22px 0;
            }

            .dropdown-panel {
                position: absolute;
                top: 100%;
                left: 50%;
                width: 244px;
                padding: 18px 18px 16px;
                border: 1px solid rgba(209, 216, 232, 0.9);
                border-radius: 26px;
                background: rgba(255, 255, 255, 1);
                box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.3);
                backdrop-filter: blur(18px);
                transform: translateX(-50%) translateY(10px);
                opacity: 0;
                visibility: hidden;
                pointer-events: none;
                transition: opacity 0.22s ease, transform 0.22s ease, visibility 0.22s ease;
                z-index: 30;

                &.is-open {
                    opacity: 1;
                    visibility: visible;
                    pointer-events: auto;
                    transform: translateX(-50%) translateY(0);
                }

                &::before {
                    content: '';
                    position: absolute;
                    top: -9px;
                    left: 50%;
                    width: 18px;
                    height: 18px;
                    border-top: 1px solid rgba(209, 216, 232, 0.9);
                    border-left: 1px solid rgba(209, 216, 232, 0.9);
                    background: rgba(255, 255, 255, 0.96);
                    transform: translateX(-50%) rotate(45deg);
                }
            }

            .dropdown-item {
                position: relative;
                padding: 15px 18px 16px;
                border-radius: 18px;
                cursor: pointer;
                transition: background-color 0.25s ease, box-shadow 0.25s ease;

                &:not(:last-child) {
                    margin-bottom: 8px;

                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: -4px;
                        height: 1px;
                        background: rgba(194, 201, 218, 0.7);
                    }
                }

                &:hover,
                &.is-active {
                    background: #dfe2ff;
                    box-shadow: inset 0 0 0 1px rgba(203, 208, 241, 0.68);
                }

                &:hover .dropdown-item__value,
                &.is-active .dropdown-item__value {
                    color: #222;
                }

                &:hover .dropdown-item__label,
                &.is-active .dropdown-item__label {
                    color: #666;
                }
            }

            .dropdown-item__value {
                font-size: 16px;
                font-weight: 700;
                line-height: 22px;
                color: #222;
            }

            .dropdown-item__label {
                margin-top: 2px;
                font-size: 12px;
                line-height: 16px;
                letter-spacing: 0.02em;
                color: #666;
            }
        }

        .right-wrap {
            display: flex;
            align-items: center;
            gap: 20px;

            // 胶囊按钮 1:1复刻
            .theme-btn {
                height: 40px;
                padding: 0 24px;
                border-radius: 999px;
                border: 1px solid rgba(200, 170, 255, 0.35);
                background: transparent;
                display: flex;
                align-items: center;
                gap: 10px;
                font-size: 16px;
                color: #A59CC2;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    border-color: rgba(233, 230, 238, 0.8);
                    color: #fff;
                }

                .divider {
                    font-size: 18px;
                    line-height: 1;
                }
            }

            .try-btn {
                height: 36px;
                padding: 8px 19px;
                border-radius: 22px;
                background: #7C50FF;
                color: #ffffff;
                font-size: 16px;
                display: flex;
                align-items: center;
                cursor: pointer;
                white-space: nowrap;
                transition: opacity 0.25s;

                &:hover {
                    opacity: 0.88;
                }
            }
        }
    }

    .mobile-header {
        height: 88px;
        padding: 22px 20px 22px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        &__logo {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
        }

        &__logo-img {
            width:165px;
            height: 43px;
            display: block;
        }

        &__toggle {
            margin-left: auto;
            width: 32px;
            height: 32px;
            padding: 0;
            border: none;
            background: transparent;
            display: inline-flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 5px;
            cursor: pointer;

            span {
                width: 24px;
                height: 2px;
                border-radius: 999px;
                background: #8B84B2;
                transition: transform 0.25s ease, opacity 0.25s ease;
            }

            &.is-open span:nth-child(1) {
                transform: translateY(7px) rotate(45deg);
            }

            &.is-open span:nth-child(2) {
                opacity: 0;
            }

            &.is-open span:nth-child(3) {
                transform: translateY(-7px) rotate(-45deg);
            }
        }
    }

    .mobile-menu-panel {
        position: absolute;
        top: 72px;
        left: 0;
        width: 100%;
        min-height: calc(100vh - 72px);
        padding: 0 24px 36px;
        background: #FFFFFF;
        box-sizing: border-box;
    }

    .mobile-menu-item {
        border-bottom: 1px solid #E7E7E7;
        padding: 25px;
        &__main {
            min-height: 64px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 32px;
            font-weight: 700;
            color: #222222;

            &.is-active {
                color: #7C50FF;
            }
        }

        &__arrow {
            width: 24px;
            height: 24px;
            border-right: 2px solid #7F7F7F;
            border-bottom: 2px solid #7F7F7F;
            transform: rotate(45deg);
            transition: transform 0.25s ease;
            margin-right: 6px;

            &.is-open {
                transform: rotate(225deg);
            }
        }
    }

    .mobile-submenu {
        padding: 4px 0 18px 24px;

        &__item {
            padding: 25px;
            min-height: 50px;
            display: flex;
            align-items: center;
            font-size: 32px;
            font-weight: 600;
            color: #222222;

            &.is-active {
                color: #7C50FF;
            }
        }
    }
}

.mobile-menu-slide-enter-active,
.mobile-menu-slide-leave-active {
    transition: opacity 0.45s ease, transform 0.45s ease;
    transform-origin: top center;
}

.mobile-menu-slide-enter,
.mobile-menu-slide-leave-to {
    opacity: 0;
    transform: scaleY(0);
}

.mobile-menu-slide-enter-to,
.mobile-menu-slide-leave {
    opacity: 1;
    transform: scaleY(1);
}

.mobile-submenu-slide-enter-active,
.mobile-submenu-slide-leave-active {
    transition: all 0.22s ease;
    overflow: hidden;
}

.mobile-submenu-slide-enter,
.mobile-submenu-slide-leave-to {
    opacity: 0;
    max-height: 0;
}

.mobile-submenu-slide-enter-to,
.mobile-submenu-slide-leave {
    opacity: 1;
    max-height: 320px;
}
</style>
